const EDIT_COVERPIC = "EDIT_COVERPIC"
const EDIT_PROFILEPIC = "EDIT_PROFILEPIC"
const EDIT_FIRSTNAME = "EDIT_FIRSTNAME"
const EDIT_LASTNAME = "EDIT_LASTNAME"
const EDIT_BIO = "EDIT_BIO"
const EDIT_URL = "EDIT_URL"
const INITIAL_EDIT_STATE = "INITIAL_EDIT_STATE"

export { EDIT_COVERPIC, EDIT_PROFILEPIC, EDIT_FIRSTNAME, EDIT_LASTNAME, EDIT_BIO, EDIT_URL, INITIAL_EDIT_STATE };